import React from 'react';
import { Link } from 'react-router-dom';
import { Badge } from '@wearenotch/ui-react';
import { Pattern } from '../../types';
import { categoryColor, ifTypeBadgeVariant } from '../../utils/categoryColors';
import { CategoryBadge } from '../CategoryBadge/CategoryBadge';
import { ComplexityIndicator } from '../ComplexityIndicator/ComplexityIndicator';
import { isNew } from '../../utils/isNew';
import styles from './PatternCard.module.css';

interface PatternCardProps {
  pattern: Pattern;
  index?: number;
}

export function PatternCard({ pattern, index = 0 }: PatternCardProps) {
  const color = categoryColor[pattern.category];

  const _isNew = isNew(pattern.created_at);

  return (
    <Link
      to={`/pattern/${pattern.id}`}
      className={styles.card}
      style={{ '--tone': color, '--i': index } as React.CSSProperties}
      data-reveal
    >
      {_isNew && <span className={styles.newBadge}>New</span>}
      <div className={styles.body}>
        <div className={styles.meta}>
          <CategoryBadge category={pattern.category} />
        </div>
        <h3 className={styles.title}>{pattern.title}</h3>
        {pattern.interface_type?.length > 0 && (
          <div className={styles.ifTypes}>
            {pattern.interface_type.map((t) => (
              <Badge key={t} variant={ifTypeBadgeVariant[t]} size="sm">{t}</Badge>
            ))}
          </div>
        )}
        {pattern.complexity && <ComplexityIndicator complexity={pattern.complexity} />}
        <p className={styles.problem}>{pattern.problem}</p>
        <div className={styles.footer}>
          <span className={styles.guidelineCount}>
            {pattern.guidelines.length} guidelines
          </span>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={styles.arrow}>
            <path d="M5 12h14M12 5l7 7-7 7" />
          </svg>
        </div>
      </div>
    </Link>
  );
}
